import React, { Component } from "react";
import { FeatureGroup } from "react-leaflet";
import { withMapControl } from "../../shared/containers/containerMapControl";
import { EditControl } from "react-leaflet-draw";
import "leaflet-draw/dist/leaflet.draw.css";

import { createGeozone, getGeozones, getGeozonesByUnit } from "./services/geozoneHelper";
import { withGeozones } from "../../shared/containers/geozonesContainer";
import { states } from "../../reducers/queriesStates";

import GeozoneListControl from "./GeozoneListControl";
import LeafletRulerWrapper from "../LeaflerRuler/LeafletRulerWrapper";

class GeozoneEditControl extends Component {
  componentDidUpdate(prevProps) {
    const {
      geozoneCreateDataState,
      onAddUnitToGeozone,
      geozoneAddUnitDataState,
      geozoneRemoveUnitDataState,
      onSelectGeozone,
      tempGeozone,
      createdId,
      carId,
      onGetGeozones,
    } = this.props;

    if (geozoneCreateDataState === states.READY && prevProps.geozoneCreateDataState === states.REQUEST) {
      if (createdId !== null && carId !== null) {
        onSelectGeozone(tempGeozone);
        onAddUnitToGeozone(createdId, { id: carId, title: "", registerNumber: "" });
      }
    }

    if (
      (geozoneAddUnitDataState === states.READY && prevProps.geozoneAddUnitDataState === states.REQUEST) ||
      (geozoneRemoveUnitDataState === states.READY && prevProps.geozoneRemoveUnitDataState === states.REQUEST)
    ) {
      onGetGeozones();
    }
  }

  onCreateGeozone(e) {
    const { onCreateGeozone, onSelectGeozone } = this.props;

    onCreateGeozone(createGeozone(e.layer));
    this.setState({ geozoneControl: false });
    onSelectGeozone(null);
  }

  onEditedGeozone(e) {
    const { onUpdateGeozone, onSelectGeozone, geozoneUpdateDataState } = this.props;

    if (geozoneUpdateDataState !== states.REQUEST) {
      e.layers.eachLayer((layer) => {
        const geozone = createGeozone(layer);

        geozone.id = layer.options.id;
        geozone.title = layer.options.title === undefined ? layer.options.geozone.title : layer.options.title;

        onUpdateGeozone(geozone.id, geozone, true);
        onSelectGeozone(null);
      });
    }
  }

  render() {
    const { mapOverlayers, onSelectGeozone, onSetMapBounds, carId } = this.props;

    if (!mapOverlayers.viewGeozones) return null;

    const geozoneLayers = getGeozones(this.props.geozones, onSelectGeozone, onSetMapBounds, carId);

    return (
      <div>
        <FeatureGroup>
          <EditControl
            position="topleft"
            onCreated={this.onCreateGeozone.bind(this)}
            onEdited={this.onEditedGeozone.bind(this)}
            edit={{
              remove: false,
            }}
            draw={{
              polyline: false,
              polygon: {
                showArea: true,
                showLength: true,
                precision: {
                  km: 3,
                },
              },
              rectangle: {
                showArea: true,
              },
              circle: {
                showRadius: true,
                metric: true,
                feet: false,
                nautic: false,
              },
              marker: false,
              circlemarker: false,
            }}
          />

          {geozoneLayers}
        </FeatureGroup>
        <GeozoneListControl geozoneItems={getGeozonesByUnit(this.props.geozones, carId)} geozoneLayers={geozoneLayers} />
        <LeafletRulerWrapper />
      </div>
    );
  }
}

export default withGeozones(withMapControl(React.memo(GeozoneEditControl)));
